export const List = () => import("./List.vue");
export const Edit = () => import("./Edit.vue");
export const Print = () => import("./Print.vue");
export const Create = () => import("./Create.vue");
export const Details = () => import("./Details.vue");
